(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["before-after-slider"] && !Shopify.designMode) return;
  try {
    class BeforeAfterSlider {
    constructor(frame) {
      this.frame = frame;
      this.range = frame.querySelector('[data-ba-range]');
      if (!this.range) return;

      this.onInput = this.onInput.bind(this);
      this.range.addEventListener('input', this.onInput);
      this.render(this.range.value);
    }

    onInput(event) {
      this.render(event.currentTarget.value);
    }

    render(value) {
      this.frame.style.setProperty('--ba-pos', `${value}%`);
    }
  }

  const initBeforeAfterSliders = (root) => {
    root.querySelectorAll('[data-ba-slider]').forEach((frame) => {
      if (frame.dataset.baInit === 'true') return;
      frame.dataset.baInit = 'true';
      new BeforeAfterSlider(frame);
    });
  };

  document.addEventListener('DOMContentLoaded', () => initBeforeAfterSliders(document));
  initBeforeAfterSliders(document);

  document.addEventListener('shopify:section:load', (event) => initBeforeAfterSliders(event.target));
  document.addEventListener('shopify:block:select', (event) => initBeforeAfterSliders(event.target));
  } catch(e) { console.error(e); }
})();

})();
